/* Ormskirk Pets cart conversion optimisations - 14 Aug 2026 */
(function () {
  function initCartOptimisations() {
    var stickyBar = document.querySelector('.op-cart-sticky-checkout');
    var mainCheckout = document.querySelector('.op-cart-main-checkout');
    var stickyTotal = document.querySelector('[data-op-cart-sticky-total]');

    if (!stickyBar || !mainCheckout) return;

    function setStickyVisible(visible) {
      stickyBar.classList.toggle('is-visible', !!visible);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.length) return;
        setStickyVisible(!entries[0].isIntersecting);
      }, {
        threshold: 0.15
      });
      observer.observe(mainCheckout);
    } else {
      setStickyVisible(true);
    }

    document.addEventListener('cart:updated', function (event) {
      if (!stickyTotal || !event.detail || !event.detail.cart) return;

      var total = Number(event.detail.cart.total_price || 0) / 100;
      stickyTotal.textContent = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(total);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartOptimisations);
  } else {
    initCartOptimisations();
  }
})();
